export default class MeiliLinesRowData {
    constructor(value) {
        this.chargeType = value.chargeType[0] || "";
        this.brand = value.brand[0] || "";
        this.loc = value.loc[0] || "";
        this.custNo = value.custNo[0] || "";
        this.desc = value.desc[0] || "";
        this.raNo = value.rano[0] || "";
        this.chCode = value.chCode[0] || "";
        this.countryCode = value.countryCode[0] || "";
        this.resNo = value.resNo[0] || "";
        this.chargePeriod = value.chargePeriod[0] || "";
        this.coDate = value.codate[0] || "";
        this.ciDate = value.cidate[0] || "";
        this.renterName = value.renterName[0] || "";
        this.prodName = value.prodName[0] || "";
        this.territory = value.territory[0] || "";
        this.voucher = value.voucher[0] || "";
        this.discount = value.discount[0] || "";
        this.amount = value.amount[0] || "";
        this.batchRef = value.batchRef[0] || "";
        this.clInd = value.clind[0] || "";
        this.stInd = value.stInd[0] || "";
    }
}